import DefaultUtils from '../../utils/default.utils'
import ApiService from '../../services/api.service'
import VueCookies from "vue-cookies"
import jwtDecode from 'jwt-decode'

const cookieTokenName = 'access_token_tvmed_app'
const cookieUserName = 'user_session_tvmed_app'

const _token = DefaultUtils.base64(DefaultUtils.getCookie(cookieTokenName))
const _user = DefaultUtils.jsonPaseStr(DefaultUtils.base64(DefaultUtils.getCookie(cookieUserName)))

const state = {
    user: typeof _user === 'boolean' ? {} : _user,
    token: _token || "",
    status: null,
    tokensExpiry: null,
}

// getters
const getters = {
    isLoggedIn: state => !!state.token,
    getToken: state => state.token,
    authStatus: state => state.status,
    tokensExpiry: state => state.tokensExpiry
}

// actions
const actions = {

    async login({ commit }, model) {
        const response = await ApiService.chamaApi("api/access/login.net", model)
 
        if (response.Sucesso) {
            commit("auth_success", response)
            return response
        } else {
            commit("auth_error")
        }
        return response
    },
    logout({ commit }) {
        commit("logout")
    },
}

// mutations
const mutations = {

    auth_request(state) {
        state.status = "loading"
    },
    auth_success(state, resp) {
        const _user = jwtDecode(resp.Token)

        state.status = "success"
        state.token = resp.Token
        state.tokensExpiry = _user.expires

        state.user = {
            Name: _user.unique_name,
            Email: _user.Email,
            RID: _user.RID,
            Role: _user.role
        }
        const tempoDeExpiracao = new Date(_user.expires).toUTCString() // 4 horas 
        VueCookies.set(cookieTokenName, resp.Token, tempoDeExpiracao)
        DefaultUtils.setUserData(state.user)
    },
    auth_error(state) {
        state.status = "error"
        state.token = null
        state.tokensExpiry = null

        VueCookies.remove(cookieTokenName)
    },
    logout(state) {
        state.status = null
        state.token = null
        state.tokensExpiry = null

        VueCookies.remove(cookieTokenName)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}